export default __webpack_public_path__ + "static/media/logo.1a21b835.svg";